import React, { useState } from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ForumIcon from '@mui/icons-material/Forum';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LogoutIcon from '@mui/icons-material/Logout';
import Badge from '@mui/material/Badge';
import { useNavigate, useLocation } from 'react-router-dom';
import Konsensus_Constants from '../constants/index.js';
import axios from 'axios';

export default function BottomTabNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  // Map current path to index
  const pathToIndex = {
    "/chat": 0,
//    "/vertex_chat": 1,
    "/forum": 1,
    "/notifications": 2,
    "/documents": 3,
    "/logout": 4,
  };

  // Map index to path
  const indexToPath = {
    0: "/chat",
//    1: "/vertex_chat",
    1: "/forum",
    2: "/notifications",
    3: "/documents",
    4: "/logout",
  };

  // Set the value based on location
  const [value, setValue] = React.useState(pathToIndex[location.pathname] ?? 0);
  const [notificationCount, setNotificationCount] = useState(0);
  const loadNotifications = async () => {
    if( window.location.href!='https://app.konsensus.tech/' && window.location.href!='https://app.dev.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/register' && window.location.href!='https://app.accept.konsensus.tech/forgotten_password'){
        const AXIOS_CONFIG = {
            headers: {
                'Content-Type':'application/json'
            }
        }
        let nem = await Konsensus_Constants._retrieveDataLocal("nem");
        //console.log(nem)
        //console.log("Retrieved nem");
        if( nem && nem.nem && nem.nem.data ){
            //console.log("Doing request");
            try{
                let response3 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/notifications', {userhash: nem.nem.data.userhash}, AXIOS_CONFIG);
                if( response3.data.error ){
                   //alert(response3.data.error);
                   console.log(response3.data.error);
                   if( response3.data.error === "No notifications" ){
                        Konsensus_Constants._storeData("nem_notifications",null);
                        setNotificationCount(0);
                   }
                }else{
                   //console.log(response3);
                   //console.log("processing notifications");
                   processNotifications();
                   Konsensus_Constants._storeData("nem_notifications",response3);
                }
            }catch(error){
                console.log(error);
            }
        }
        setTimeout(loadNotifications, 60000);
    }
  };
      const processNotifications = async () => {
        let notifications = await Konsensus_Constants._retrieveDataLocal("nem_notifications");
        if( notifications && notifications.nem_notifications ){
            let notificationCount = 0; // declare this variable
            for (var i = 0; i < notifications.nem_notifications.data.data.length; i++) {  // use < instead of <= to avoid index out of range
              if (notifications.nem_notifications.data.data[i].viewed === '0') {
                notificationCount++;
              }
            }
            setNotificationCount(notificationCount);
            //console.log("Count: "+notificationCount);
        }
      };

  React.useEffect(() => {
    const firstSegment = "/"+location.pathname.split('/').filter(Boolean)[0] || '';
    setValue(pathToIndex[firstSegment] ?? 0);
    loadNotifications();
    // eslint-disable-next-line
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(indexToPath[newValue]);
  };

  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, paddinTop:20, color: '#00aaaf'}} elevation={3}>
      <BottomNavigation value={value} onChange={handleChange} showLabels style={{color: '#00aaaf'}}>
        {/*<BottomNavigationAction label="Chat" icon={<ChatBubbleOutlineIcon />} sx={{
                                                                                  color: 'gray', // Color when not selected
                                                                                  '&.Mui-selected': {
                                                                                    color: '#00aaaf', // Color when selected
                                                                                  }
                                                                                }} />*/}
        <BottomNavigationAction label="Chat" icon={<ChatBubbleOutlineIcon />} sx={{
                                                                                  color: 'gray', // Color when not selected
                                                                                  '&.Mui-selected': {
                                                                                    color: '#00aaaf', // Color when selected
                                                                                  }
                                                                                }} />
{/*        <BottomNavigationAction label="Vertex Chat" icon={<ChatBubbleOutlineIcon />} sx={{
                                                                                  color: 'gray', // Color when not selected
                                                                                  '&.Mui-selected': {
                                                                                    color: '#00aaaf', // Color when selected
                                                                                  }
                                                                                }} />*/}
        <BottomNavigationAction label="Discussions" icon={<ForumIcon />} sx={{
                                                                       color: 'gray', // Color when not selected
                                                                       '&.Mui-selected': {
                                                                         color: '#00aaaf', // Color when selected
                                                                       }
                                                                       }} />
        <BottomNavigationAction
          label="Notifications"
          icon={
            <Badge badgeContent={notificationCount} color="error">
              <NotificationsIcon />
            </Badge>
          }
          sx={{
            color: 'gray', // Color when not selected
            '&.Mui-selected': {
              color: '#00aaaf', // Color when selected
            }
          }}
        />

        <BottomNavigationAction label="Documents" icon={<DocumentScannerIcon />} sx={{
                                                                       color: 'gray', // Color when not selected
                                                                       '&.Mui-selected': {
                                                                         color: '#00aaaf', // Color when selected
                                                                       }
                                                                       }} />

        <BottomNavigationAction label="Logout" icon={<LogoutIcon />} sx={{
                                                                       color: 'gray', // Color when not selected
                                                                       '&.Mui-selected': {
                                                                         color: '#00aaaf', // Color when selected
                                                                       }
                                                                       }} />
      </BottomNavigation>
    </Paper>
  );
}